import RequestAbstract from "../abstract";

export default class CurrencyExchangePairs extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/currency-exchange-pairs";
    }
}
